import {UUID} from '@util/types';
import {Ord, ordNumber, ordString} from 'fp-ts/lib/Ord';

export class MyBusinessRelationResult {
  constructor(
    public readonly mine: BusinessInitiationResource,
    public readonly total: {[key: string]: number},
  ) {}
}

export class BusinessInitiationResource {
  constructor(
    public readonly companyId: UUID,
    public readonly startupId: UUID,
    public readonly status: BusinessInitiationStatus,
    public readonly modified: Date,
    public readonly feedbackTestlistung: FeedbackListung,
    public readonly feedbackListung: FeedbackListung,
  ) {}
}
export enum BusinessInitiationStatus {
  keinKontakt = 'KeinKontakt',
  kontaktAufgenommen = 'KontaktAufgenommen',
  listungsgespraeche = 'Listungsgespraeche',
  testlistung = 'Testlistung',
  listungGeplant = 'ListungGeplantOderAktuell',
  wiederAusgelistet = 'WiederAusgelistet',
}

export enum FeedbackListung {
  schnelldreher = 'Schnelldreher',
  langsamdreher = 'Langsamdreher',
  flop = 'Flop',
}

function biStatusToIndex(s: BusinessInitiationStatus) {
  return Object.values(BusinessInitiationStatus).indexOf(s);
}

export const ordBIStatus: Ord<BusinessInitiationStatus> = {
  equals: ordString.compare as any,
  compare: (x, y) => ordNumber.compare(biStatusToIndex(x), biStatusToIndex(y)),
};
